import type { subscription as en } from '@/i18n/locales/en/subscription';
import type { Translation } from '@/i18n/types';

export const subscription: Translation<typeof en> = {
  title: 'Suscripción',
  lead: 'Gestiona tu propia suscripción: plan, pago y cancelación.',
  dialogCancel: 'Cancelar',
  status: {
    title: 'Estado',
    active: 'Activa',
    inactive: 'Inactiva',
    tier: 'Plan',
    expires: 'Caduca',
    autoRenews: 'Se renueva automáticamente',
    doesNotRenew: 'No se renueva',
    nextCharge: 'Próximo cargo',
    blocked: 'No puedes iniciar una suscripción web ahora mismo.',
  },
  plans: {
    title: 'Planes',
    monthly: 'Mensual',
    yearly: 'Anual',
    perMonth: '{{price}} / mes',
    perYear: '{{price}} / año',
    subscribe: 'Suscribirse',
    current: 'Plan actual',
    switchToYearly: 'Cambiar a anual',
    switchToMonthly: 'Cambiar a mensual',
    switchWarning:
      'Cambiar cancela tu suscripción actual e inicia la nueva de inmediato con el mismo mandato de pago. El solapamiento entre los dos periodos no se reembolsa — es posible que se te cobre dos veces por él.',
    switchConfirm: 'Sí, cambiar de plan',
    blocked: 'Ya tienes una suscripción activa, así que no se puede iniciar otro plan ahora mismo.',
  },
  manage: {
    title: 'Gestionar',
    cancel: 'Cancelar suscripción',
    cancelConfirm: 'Sí, cancelar',
    cancelled: 'Cancelada — el acceso se mantiene hasta {{date}}.',
    proRataNote:
      'En el plan anual, cancelar después del primer periodo de pago reembolsa los meses completos no utilizados y termina el acceso de inmediato en lugar de al final del periodo.',
    withdraw: 'Retractarse (dentro de 14 días)',
    withdrawHint: 'Disponible durante 14 días tras tu primer pago, una vez, por suscripción.',
  },
  history: {
    title: 'Historial',
    empty: 'Aún no hay compras.',
    date: 'Fecha',
    period: 'Periodo',
    channel: 'Canal',
    state: 'Estado',
    state_granted: 'Concedida',
    state_refunded: 'Reembolsada',
    state_revoked: 'Revocada',
    state_charged_back: 'Contracargo',
    state_rejected: 'Rechazada',
    invoice: 'Factura',
    withdrawLink: 'Retractarse',
    manageLink: 'Gestionar en la tienda',
  },
  checkout: {
    title: 'Pago',
    lead: 'Revisa tu plan antes de continuar a Mollie.',
    plan: 'Plan',
    price: 'Precio',
    consentLabel:
      'Quiero que el servicio comience de inmediato y entiendo que, si me retracto, pagaré proporcionalmente por la parte ya utilizada.',
    start: 'Continuar a Mollie',
    errorAlreadySubscribed: 'Ya tienes una suscripción activa.',
    errorProductUnavailable: 'Este plan no está disponible en este momento.',
  },
  return: {
    title: 'Estado del pago',
    waiting: 'Todavía estamos esperando la confirmación del pago.',
    success: 'Pago recibido — tu suscripción está activa.',
    backToSubscription: 'Volver a tu suscripción',
  },
  withdraw: {
    title: 'Retractarte de tu suscripción',
    lead: 'Retractarte dentro de tu plazo de 14 días termina tu acceso de inmediato — a diferencia de cancelar, que se mantiene hasta el final del periodo que ya has pagado.',
    refundTypeFull: 'Recibirás un reembolso completo.',
    refundTypeProRata: 'Recibirás un reembolso proporcional por la parte aún no utilizada.',
    refundAmount: 'Importe del reembolso',
    deadline: 'Fecha límite',
    confirm: 'Retractarse y terminar el acceso ahora',
    confirmed: 'Retractado — se reembolsará {{amount}}.',
    errorWindowExpired: 'El plazo de retractación de 14 días ha pasado.',
    errorAlreadyWithdrawn: 'Ya te has retractado de esta suscripción.',
  },
};
